import React, { useState } from "react";

import Context from "../../../../../../context";
import values from "../../../../../../values";
import {
  CustomButton2,
  CustomModal,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import { useTranslation } from "react-i18next";

const DisApprove = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedWithdrawal,
    withdrawalUpdateOne,
  } = React.useContext(Context.WithdrawalScreen);

  const [textArea, setTextArea] = useState<string>("");
  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="school-approve-modal-container">
      <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "DIS_APPROVE"}>
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="form-row">
            <CustomView.Column>
              <CustomView.Column medium={8} className="form-colum dropdown description-input">
                <div><label className="form-label">{t("description")}</label></div>
                <textarea cols={33} rows={3} onChange={(e) => setTextArea(e.target.value)}>{textArea}</textarea>
              </CustomView.Column>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2
                isLoading={isLoading}
                onClick={() => {
                  withdrawalUpdateOne({
                    type: 'REJECT',
                    _id: selectedWithdrawal?._id,
                    description: textArea,
                  });
                  setShowModal!("NONE");
                }}
                title={t("reject")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column>{}</CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default DisApprove;
